function isBaseToken(token) {
    return "defuseAssetId" in token;
}
function isUnifiedToken(token) {
    return "unifiedAssetId" in token;
}
function isFungibleToken(token) {
    return isBaseToken(token) && "address" in token && token.address !== "native";
}
function isNativeToken(token) {
    return isBaseToken(token) && "type" in token && token.type === "native";
}
function getTokenId(token) {
    if (isBaseToken(token)) {
        return token.defuseAssetId;
    }
    if (isUnifiedToken(token)) {
        return token.unifiedAssetId;
    }
    throw new Error("Invalid token type");
}

export { getTokenId, isBaseToken, isFungibleToken, isNativeToken, isUnifiedToken };
//# sourceMappingURL=token.js.map
